import React from "react";

import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";

/**
 * A common component used by property cards to display customizable text fields.
 */
interface ITextFieldPropertyProps {
    label?: string;
    value?: string;
    tooltip?: string;
    placeholder?: string;
    editable?: boolean;
    readOnly?: boolean;
    multiline?: boolean;
    onValueChange: (value: string) => void;
}

const TextFieldProperty: React.FC<ITextFieldPropertyProps> = ({ ...props }) => {
    // const value = React.useMemo(() => props.value, [props.value]);
    const [localValue, setLocalValue] = React.useState(props.value || "");

    React.useEffect(() => {
        setLocalValue(props.value || "");
    }, [props.value]);

    return (
        <Stack direction="row" spacing={2} alignItems="center">
            {props.label && (
                <Typography variant="subtitle1" component="div" sx={{ whiteSpace: 'nowrap' }}>
                    {props.label}:
                </Typography>
            )}
            <Tooltip title={props.tooltip || ""} arrow>
                {props.readOnly ?
                    <Typography variant="body1" component="div" sx={{ color: 'text.secondary' }}>
                        {props.value}
                    </Typography>
                    :
                    <TextField
                        size="small"
                        fullWidth
                        value={localValue}
                        // onChange={(e) => props.onValueChange(e.target.value)}
                        onChange={(e) => setLocalValue(e.target.value)}
                        onBlur={() => {
                            if (localValue !== props.value) {
                                props.onValueChange(localValue);
                            }
                        }}
                        disabled={!props.editable}
                        placeholder={props.placeholder}
                        multiline={props.multiline}
                        rows={props.multiline ? 4 : 1}
                    />
                }
            </Tooltip>
        </Stack>
    );
}

export default TextFieldProperty;
